function AddReadMore() {
    // Set the character limit after which "Read More" is applied
    var charLimit = 120;
    var readMoreText = " ...read more";
    var readLessText = " read less";

    document.querySelectorAll(".add-read-more").forEach(function (element) {
        if (element.querySelector(".first-section")) return;

        var allContent = element.innerHTML; // Preserve original HTML structure
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = allContent;

        var contentLength = tempDiv.textContent.length;

        // Only process if content length exceeds the character limit
        if (contentLength > charLimit) {
            var visibleContent = "";
            var hiddenContent = "";
            var currentLength = 0;

            Array.from(tempDiv.childNodes).forEach(function (node) {
                var nodeText = node.textContent || node.innerText || "";
                if (currentLength + nodeText.length <= charLimit) {
                    visibleContent += node.outerHTML || node.nodeValue;
                    currentLength += nodeText.length;
                } else {
                    if (currentLength < charLimit) {
                        var visiblePart = nodeText.substring(0, charLimit - currentLength);
                        if (node.nodeType === Node.TEXT_NODE) {
                            visibleContent += visiblePart;
                        } else {
                            var clone = node.cloneNode();
                            clone.textContent = visiblePart;
                            visibleContent += clone.outerHTML;
                        }
                        hiddenContent += nodeText.substring(charLimit - currentLength);
                        currentLength = charLimit;
                    } else {
                        hiddenContent += node.outerHTML || node.nodeValue;
                    }
                }
            });

            var strToAdd =
                `<span class="first-section">${visibleContent}</span>` +
                `<span class="second-section" style="display: none;">${hiddenContent}</span>` +
                `<span class="read-more" title="Click to Show More">${readMoreText}</span>` +
                `<span class="read-less" title="Click to Show Less" style="display: none;">${readLessText}</span>`;
            element.innerHTML = strToAdd;
        }
    });

    // Toggle visibility on click
    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("read-more")) {
            var parent = event.target.closest(".add-read-more");
            parent.querySelector(".second-section").style.display = "inline";
            parent.querySelector(".read-more").style.display = "none";
            parent.querySelector(".read-less").style.display = "inline";
        } else if (event.target.classList.contains("read-less")) {
            var parent = event.target.closest(".add-read-more");
            parent.querySelector(".second-section").style.display = "none";
            parent.querySelector(".read-more").style.display = "inline";
            parent.querySelector(".read-less").style.display = "none";
        }
    });
}

AddReadMore();




var headers = document.querySelectorAll('.toggle-header');

  for (var i = 0; i < headers.length; i++) {
    headers[i].addEventListener('click', function() {
      var content = this.nextElementSibling;

      // Toggle visibility
      if (content.style.height === "0px" || content.style.height === "") {
        content.style.height = content.scrollHeight + "px"; // Dynamically set height
        content.style.opacity = "1";
        this.classList.add('expanded'); // Add class to parent header
      } else {
        content.style.height = "0px";
        content.style.opacity = "0";
        this.classList.remove('expanded'); // Remove class from parent header
      }
    });
  }


<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
  let isScrollLogoVisible = false;

function handleScroll() {
    // Only apply the logic if the screen width is above 1000px
    if (window.innerWidth > 1000) {
        const scrollUpLogo = document.getElementById("scrollUpLogo");
        const scrollLogo = document.getElementById("scrollLogo");

        // Check if we've scrolled more than 5px
        if (window.scrollY >= 1 && !isScrollLogoVisible) {
            // Show scrollLogo and hide scrollUpLogo
            scrollUpLogo.classList.add("hidden");
            scrollLogo.classList.remove("hidden");

            isScrollLogoVisible = true; // Update the visibility state
        } else if (window.scrollY < 1 && isScrollLogoVisible) {
            // Show scrollUpLogo and hide scrollLogo
            scrollUpLogo.classList.remove("hidden");
            scrollLogo.classList.add("hidden");

            isScrollLogoVisible = false; // Update the visibility state
        }
    }
}

// Attach the scroll event listener
document.addEventListener("scroll", handleScroll);

// Optional: Adjust logo visibility on window resize
window.addEventListener("resize", () => {
    // Reset visibility if resizing below 1000px
    if (window.innerWidth <= 1000) {
        document.getElementById("scrollUpLogo").classList.remove("hidden");
        document.getElementById("scrollLogo").classList.add("hidden");
        isScrollLogoVisible = false; // Reset state
    }
});

document.addEventListener("DOMContentLoaded", function () {
  // Select all tag list items
  const tagItems = document.querySelectorAll(".tags-list-item");

  // Retrieve the active tag from localStorage, if it exists
  const activeTag = localStorage.getItem("activeTag");

  // If there's an active tag in localStorage, apply the 'active' class to that tag
  if (activeTag) {
    tagItems.forEach((item) => {
      const link = item.querySelector("a");
      if (link && link.textContent.trim().toLowerCase() === activeTag.toLowerCase()) {
        item.classList.add("tag-active");
      }
    });
  }

  // Loop through each tag item to add click event listener
  tagItems.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent immediate navigation

      const link = this.querySelector("a");
      const tagName = link.textContent.trim(); // Get the name of the tag clicked
      const tagNameEncoded = tagName.toLowerCase().replace(/\s+/g, '-'); // Encode tag name (replace spaces with hyphens)

      // Get current URL path (without query string or hash)
      const currentUrl = window.location.href.split('?')[0].split('#')[0];

      // Extract the tag part of the URL (if any)
      const currentTagMatch = currentUrl.match(/\/tagged\/([^\/]+)/);

      // If the current tag is already active (clicking the active tag)
      if (currentTagMatch && currentTagMatch[1] === tagNameEncoded) {
        // Remove the tag from the URL, revert to the initial state (no tag)
        const newUrl = currentUrl.replace(`/tagged/${tagNameEncoded}`, "");

        // Update the URL without reloading the page
        history.pushState(null, '', newUrl);

        // Remove the active class from the tag
        item.classList.remove("tag-active");

        // Remove the active tag from localStorage
        localStorage.removeItem("activeTag");

        // Reload the page to show all blogs
        window.location.reload();
      } else {
        // If the current tag is not active, update the URL with the new tag
        let newUrl = currentUrl;
        if (currentTagMatch) {
          newUrl = currentUrl.replace(`/tagged/${currentTagMatch[1]}`, "");
        }
        newUrl = newUrl + `/tagged/${tagNameEncoded}`;

        // Update the URL without reloading the page
        history.pushState(null, '', newUrl);

        // Update the active class on the clicked tag
        tagItems.forEach((tag) => tag.classList.remove("tag-active")); // Remove active class from all
        this.classList.add("tag-active"); // Add active class to the clicked tag

        // Store the active tag in localStorage
        localStorage.setItem("activeTag", tagName);

        // Reload the page to reflect the filtered posts for the clicked tag
        window.location.reload();
      }
    });
  });
});

// Smooth scrolling with 260px header offset
document.querySelectorAll('.jump-to a').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    const headerOffset = 270; // Adjust for a fixed 260px header height
    const targetElement = document.querySelector(this.getAttribute('href'));
    const elementPosition = targetElement.offsetTop;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  });
});

// // Select all thumbnails and the featured image
// const thumbnails = document.querySelectorAll('.thumbnails img');
// const featuredImage = document.getElementById('featured');

// // Set the initial featured image to the first thumbnail
// featuredImage.src = thumbnails[0].src.replace('thumb', 'featured');

// // Add click event listeners to all thumbnails
// thumbnails.forEach((thumbnail, index) => {
//   thumbnail.addEventListener('click', () => {
//     // Update the featured image based on the clicked thumbnail
//     featuredImage.src = thumbnail.src.replace('thumb', 'featured');

//     // Optional: Add a border to the active thumbnail
//     thumbnails.forEach(thumb => (thumb.style.borderColor = 'transparent'));
//     thumbnail.style.borderColor = '#007bff';
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
    const button = document.querySelector('.shopify-payment-button__button');
    if (button) {
        button.textContent = 'Buy now';
    }
});
